import { render, staticRenderFns } from "./RecycleTips.vue?vue&type=template&id=facf899e"
import script from "./RecycleTips.vue?vue&type=script&lang=js"
export * from "./RecycleTips.vue?vue&type=script&lang=js"
import style0 from "./RecycleTips.vue?vue&type=style&index=0&id=facf899e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports